
export const STATUS_IMAGE = {
  MO: '/icons/cross.svg',
  PO: '/icons/partial.svg',
  PD: '/icons/degraded.svg',
  UM: '/icons/maintenance.svg',
  OP: '/icons/tick.svg'
};

export const STATUS = {
  OP: 'Operational',
  PD: 'Degraded Performance',
  UM: 'Under Maintenance',
  PO: 'Partial Outage',
  MO: 'Major Outage'
};

export const STATUSABBREV = {
  MO: { label: 'Major Outage', color: '#c02601' },
  PO: { label: 'Partial Outage', color: '#e47d00' },
  PD: { label: 'Degraded Performance', color: '#ecb31f' },
  UM: { label: 'Under Maintenance', color: '#2063e3' },
  OP: { label: 'Operational', color: '#29B15C' }
};
                                                    